import { Component, OnInit, Renderer2, ViewChild, ElementRef, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { CandidateService } from 'src/app/_services/candidate.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';


@Component({
  selector: 'app-candidate-filter',
  templateUrl: './candidate-filter.component.html',
  styleUrls: ['./candidate-filter.component.scss']
})

export class CandidateFilterComponent implements OnInit {
  removeFilter: any;
  locationsview:any
  locationsListOpen:any
  departmentType: any;
  candidateNameRes: any
  jobTitleRes: any;
  locationRes: any
  selectedName: any[] = [];
  selectedJobTitle: any[] = [];
  selectedLocation: any[] = [];
  isEmailChecked: boolean;
  isPhoneChecked: boolean;
  userid: any;
  filterApplied: boolean;
  timeout: any;
  
  locationTypeValue: any = ''
  firstNameValue: any = ''
  departmentTypeValue: any = ''
  talentpoolnumber: any;
  companylist: any
  selectedcompany: any[] = []
  taglist: any
  selectedtags: any = []
  selectedrevealcontact: any
  candidateFilterForm = new FormGroup({
    candidatename: new FormControl(null),
    currentjobtitle: new FormControl(null),
    currentlocation: new FormControl(null),
    currentcompany: new FormControl(null),
    tags: new FormControl(null),
    revealdata: new FormControl('All')

  })
  showCandidateNameLoader: boolean=false;
  showJobtitleLoader: boolean=false;
  showLocationLoader: boolean=false;
  showCompanyLoader: boolean=false;
  showTagLoader: boolean=false;
  constructor(private renderer: Renderer2,
    public _candidateservice: CandidateService, private localstorageservice:LocalStorageService){
    this.renderer.listen('window', 'click', (e: Event) => {
     
      if (this.locationsview && e.target !== this.locationsview.nativeElement) {
        this.locationsListOpen = false;
      }
   
    });
   }
   @Output() filterEvent: EventEmitter<{}>= new EventEmitter<Event>();
   @Input() events: Observable<void>;

  multiSelectOptions: string[] = ['Webbtree Verified', 'Webbtree Introduction'];
  selectedContactRequest: string[] = [];

  ngOnInit() {
    this.events.subscribe((event: any) => {
      this.removeFilter = event.removeFilter
      let getFilter = event.getFilter
      if(this.removeFilter == true){
        this.resetFilter();
      }

      if(event.talentpoolnumber){
        this.talentpoolnumber = event.talentpoolnumber
      }
      
      if(getFilter == true){
        this.filter()
      }
    })
    this.getUserDetails()
  }

  filterSlider_close() {
    document.getElementById("mySidebar_filter").style.display = "none";
    document.getElementById("myOverlay_filter").style.display = "none";
  }

  resetFilter(type?){
    this.selectedLocation = []
    this.selectedName = []
    this.selectedJobTitle = []
    this.isEmailChecked = false
    this.isPhoneChecked = false
    this.locationTypeValue = ''
    this.firstNameValue = ''
    this.departmentTypeValue = ''
    this.selectedcompany = []
    this.selectedtags = []
    this.selectedrevealcontact = 'All';
    this.candidateFilterForm.patchValue({revealdata: 'All'})
    this.selectedContactRequest = []
    
    if(type){
      this.filter(true)
    }


    document.getElementById("mySidebar_filter").style.display = "none"; 
    document.getElementById("myOverlay_filter").style.display = "none";

  }

  onKeyPress(element, event){
    this.filterApplied = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.filterTypeaheads(element, event);
    },500);
  }


  
  filterTypeaheads(element, event){
    let data = {};
    let inputText = event.target.value;
    if(this.talentpoolnumber){
      data['talentpoolnumber'] =  this.talentpoolnumber
     }
    if(element == 'fullname'){
      data['candidatenamepayload'] = inputText,
      data['selectedjobtitles'] = this.selectedJobTitle ? this.selectedJobTitle.map(x => x.jobtitle) : ''
      data['selectedlocations'] = this.selectedLocation ? this.selectedLocation.map(x => x.locationname) : ''
      data['isemailavailable'] = this.isEmailChecked ? true : false
      data['isphoneavailable'] =  this.isPhoneChecked ? true : false
      if(inputText.trim().length >= 0){
        this._candidateservice.getCandidateNameTypeahead(data).subscribe((res : any) => {
          this.candidateNameRes = res;
        });
      }
    }else if(element == 'jobtitle'){
      data['selectedcandidates'] = this.selectedName ? this.selectedName.map(x => ({
        firstname : x.firstname,
        lastname: x.lastname
      })) : '';
      data['jobtitles'] = inputText
      data['selectedlocations'] = this.selectedLocation ? this.selectedLocation.map(x => x.locationname) : ''
      data['isemailavailable'] = this.isEmailChecked ? true : false
      data['isphoneavailable'] =  this.isPhoneChecked ? true : false
      if(inputText.trim().length >= 0){
        this._candidateservice.getjobListTypeahead(data).subscribe((res : any) => {
          this.jobTitleRes = res;
        });
      }
    }else if(element == 'location'){
      data['selectedcandidates'] = this.selectedName ? this.selectedName.map(x => ({
        firstname : x.firstname,
        lastname: x.lastname
      })) : '';
      data['selectedjobtitles'] = this.selectedJobTitle ? this.selectedJobTitle.map(x => x.jobtitle) : ''
      data['locations'] = inputText
      data['isemailavailable'] = this.isEmailChecked ? true : false
      data['isphoneavailable'] =  this.isPhoneChecked ? true : false
      if(inputText.trim().length >= 0){
        this._candidateservice.getLocationTypeahead(data).subscribe((res : any) => {
          this.locationRes = res;
        });
      }
    }
  }

  filter(isReset = null){
    let payload = {}
    payload['filtercount'] = 0
    if(this.selectedLocation && this.selectedLocation.length > 0){
      payload['selectedlocations'] = this.selectedLocation.map(x => x.locationname)
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.selectedName && this.selectedName.length > 0){
      payload['selectedcandidates'] = this.selectedName.map(x => ({
        firstname : x.firstname,
        lastname: x.lastname
      }))
      payload['filtercount'] = payload['filtercount'] + 1
    } 
    if(this.selectedJobTitle && this.selectedJobTitle.length > 0){
      payload['selectedjobtitles'] = this.selectedJobTitle.map(x => x.jobtitle)
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.selectedcompany && this.selectedcompany.length > 0) {
      payload['selectedcompanynames'] = this.selectedcompany.map(x=>x.companyname)
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.selectedtags && this.selectedtags.length > 0) {
      payload['selectedtags'] = this.selectedtags.map(x=>x.tagid)
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.selectedrevealcontact &&  this.selectedrevealcontact != 'All'){
      payload['selectedrevealcontact'] = this.selectedrevealcontact 
      payload['filtercount'] = payload['filtercount'] + 1
    }
    if(this.isPhoneChecked){
      payload['isphoneavailable'] =  this.isPhoneChecked ? true : false
    }
    if(this.selectedContactRequest && this.selectedContactRequest.length){
      payload['selectedcontactrequested'] = this.selectedContactRequest
    }
    let data = {
      payload: payload,
      isReset: isReset
    }
    this.filterEvent.emit(data);
  }
  
  

  selectTypeahead(element, data){
    if(element == 'fullname'){
      let filteredName = this.selectedName.filter(x => x.candidateid == data.candidateid)
      if(filteredName && filteredName.length == 0){
        this.selectedName.push(data);
      }
    }else if(element == 'jobtitle'){
      let filteredJobtitle = this.selectedJobTitle.filter(x => x.jobtitle == data.jobtitle)
      if(filteredJobtitle && filteredJobtitle.length == 0){
        this.selectedJobTitle.push(data);
      }
    }else if(element == 'location'){
      let filteredLocation = this.selectedLocation.filter(x => x.locationname == data.locationname)
      if(filteredLocation && filteredLocation.length == 0){
        this.selectedLocation.push(data);
      }
    }
    this.filter()
  }


  unselect(data, element){
    if(element == 'candidate'){
      this.selectedName = this.selectedName.filter(x => x.candidateid != data.candidateid)
    }else if(element == 'jobtitle'){
      this.selectedJobTitle = this.selectedJobTitle.filter(x => x.jobtitle != data.jobtitle)
    } else if(element == 'location'){
      this.selectedLocation = this.selectedLocation.filter(x => x.locationname != data.locationname)
    } else if(element == 'company'){
      this.selectedcompany = this.selectedcompany.filter(x => x.companyname != data.companyname)
    } else if(element == 'tags'){
      this.selectedtags = this.selectedtags.filter(x => x.tagtext != data.tagtext)
    }else if(element == 'selectedContactRequest'){
      this.selectedContactRequest = this.selectedContactRequest.filter(x  => x != data) // saved in array 
    }

    this.filter()
  }

  checkEmail(event){
    if(event.target.checked == true){
      this.isEmailChecked = true
    }else{
      this.isEmailChecked = false
    }
    this.filter()
  }

  checkPhone(event){
    if(event.target.checked == true){
      this.isPhoneChecked = true
    }else{
      this.isPhoneChecked = false
    }
    this.filter()
  }

  getUserDetails(){
    this.userid = this.localstorageservice.getItem('userid')
  }

  getTypeaheads(type, event) {
    let data = {}
    let value = event
    if(this.talentpoolnumber){
      data['talentpoolnumber'] =  this.talentpoolnumber
     }
    data['selectedjobtitles'] = this.selectedJobTitle ? this.selectedJobTitle.map(x => x.jobtitle) : ''
    data['selectedlocations'] = this.selectedLocation ? this.selectedLocation.map(x => x.locationname) : ''
    data['iscontactrevealed'] = this.candidateFilterForm.getRawValue().revealdata
    data['selectedtags'] = this.selectedtags ? this.selectedtags.map(x=>x.tagtext): ''
    data['selectedcompanynames'] = this.selectedcompany ? this.selectedcompany.map(x=>x.companyname): ''
    data['selectedcandidates'] = this.selectedName ? this.selectedName.map(x => ({
      firstname : x.firstname,
      lastname: x.lastname
    })) : '';
    if(type == 'candidatename') {
      data['candidatenamepayload'] = value,
      this.showCandidateNameLoader= true
      this._candidateservice.getCandidateNameTypeahead(data).subscribe((res : any) => {
        this.candidateNameRes = res;
        this.showCandidateNameLoader=false
      });
    } else if(type == 'jobtitle') {
      data['jobtitles'] = value
      this.showJobtitleLoader= true
      this._candidateservice.getjobListTypeahead(data).subscribe((res : any) => {
        this.jobTitleRes = res;
      this.showJobtitleLoader= false

      });
    } else if(type == 'location') {
      data['locations'] = value
      this.showLocationLoader= true
      this._candidateservice.getLocationTypeahead(data).subscribe((res : any) => {
        this.locationRes = res;
      this.showLocationLoader= false
      });
    } else if(type == 'company') {
        data['companynames'] = value
        this.showCompanyLoader= true
      this._candidateservice.getCompanyTypeahead(data).subscribe((res:any)=>{
        this.companylist = res
        this.showCompanyLoader= false
      })
    } else if(type == 'tags') { 
      data['tags'] = value
      this.showTagLoader= true
      this._candidateservice.typeaheadTags(data).subscribe((res:any)=>{
        this.taglist = res
        this.showTagLoader= false
      })
    }
  }

  selectOption(event, type) {
    if(type == 'candidatename') {
      this.candidateFilterForm.patchValue({candidatename: null})
      this.selectedName.push(event);
    } else if(type == 'jobtitle') {
      this.candidateFilterForm.patchValue({currentjobtitle: null})
      this.selectedJobTitle.push(event);
    } else if(type == 'location') {
      this.candidateFilterForm.patchValue({currentlocation: null})
      this.selectedLocation.push(event)
    } else if(type == 'company') {
      this.candidateFilterForm.patchValue({currentcompany: null})
      this.selectedcompany.push(event)
    } else if(type == 'tags') {
      this.candidateFilterForm.patchValue({tags: null})
      this.selectedtags.push(event)
    }
    this.filter()
  }

  changereveal(event) {
    if(event.target.checked == true) {
      this.selectedrevealcontact = event.target.value
      this.candidateFilterForm.patchValue({
        revealdata: event.target.value
      })
    }
    this.filter()
  }

  
  toggleOption(option: string) {
    if (this.selectedContactRequest.includes(option)) {
      this.selectedContactRequest = this.selectedContactRequest.filter((selected) => selected !== option);
    } else {
      this.selectedContactRequest.push(option);
    }
    this.filter()
  }

}
